<template>
  <v-form v-model="valid" ref="form">
    <v-btn
      class="primary"
      tile
      width="245"
      height="60"
      text
      @click="dialog = true"
    >Add new administrator</v-btn>
    <v-dialog max-width="600px" v-model="dialog">
      <v-card>
        <v-card-title>
          <span class="headline">Add administrator</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="pa-0">
                <v-text-field outlined label="Name" v-model="admin.name" :autofocus="true" :rules="nameRules"></v-text-field>
                <v-text-field outlined label="Email" v-model="admin.email" :rules="emailRules"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters justify="end">
            <v-col cols="auto">
              <v-btn
                outlined
                tile
                class="ma-2"
                color="primary"
                @click.prevent="dialog = false"
              >Cancel</v-btn>
              <v-btn
                tile
                text
                class="ma-2 primary"
                @click.prevent="onClickadministrator"
                :loading="loading"
                :disabled="loading"
              >Add administrator</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";

export default Vue.extend({
  name: "AdminForm",
  data() {
    return {
      dialog: false,
      admin: {},
      loading: false,
      valid: false,
      nameRules: [v => !!v || "Name is required",],
      emailRules: [
        v => !!v || "Email is required",
        v =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid"
      ]
    };
  },
  methods: {
    ...mapActions(["addAdmin", "setSnackbar"]),
    async onClickadministrator() {
      this.$refs.form.validate();
      if (!this.valid) return;
      this.loading = true;
      try {
        await this.addAdmin(this.admin);
        this.dialog = false;
        this.loading = false;
        this.admin = {};
        this.setSnackbar({
          text: `Admin Added.`
        });
      } catch (error) {
        // console.log(error);
      }
    }
  }
});
</script>
